import React from "react";
import { ArrowRight } from "lucide-react";

/* Premium CTA button. Rectangular/minimal, teal primary, gold + outline variants. */
export const CTAButton = React.forwardRef(
  ({ variant = "primary", children, className = "", withArrow = false, as = "button", ...props }, ref) => {
    const base =
      "group inline-flex items-center justify-center gap-2 font-display font-semibold text-sm tracking-tight rounded-sm px-6 py-3.5 transition-colors duration-300 focus-ring disabled:opacity-60 disabled:pointer-events-none";
    const variants = {
      primary: "bg-teal text-white hover:bg-[#08929f]",
      gold: "bg-gold text-[#0C1B2E] hover:bg-[#c39a35]",
      outlineLight:
        "border border-[rgba(246,248,250,0.35)] text-white hover:bg-white hover:text-[#0C1B2E]",
      outlineDark:
        "border border-[rgba(12,27,46,0.25)] text-navy hover:bg-navy hover:text-white",
      ghostLight: "text-white/90 hover:text-white",
    };
    const Tag = as;
    return (
      <Tag ref={ref} className={`${base} ${variants[variant]} ${className}`} {...props}>
        {children}
        {withArrow && (
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        )}
      </Tag>
    );
  }
);
CTAButton.displayName = "CTAButton";

export const SectionHeading = ({ eyebrow, children, dark = false, className = "" }) => (
  <div className={className}>
    {eyebrow && (
      <div className="flex items-center gap-3 mb-5">
        <span className="h-px w-8 bg-teal" />
        <span className={`eyebrow ${dark ? "text-teal" : "text-teal"}`}>{eyebrow}</span>
      </div>
    )}
    <h2
      className={`font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.08] max-w-4xl ${
        dark ? "text-white" : "text-navy"
      }`}
    >
      {children}
    </h2>
  </div>
);
